import ApiService from '../apiservice'

class ProjecaoUsuarioSevice extends ApiService {
  constructor() {
    super('/projecaoUsuario')
  }

  cadastrar(projecao) {
    return this.post('/',projecao);
  }

  listar(filtro) {
    console.log('Filtro', filtro);
    return this.get(`/consulta?empresa=${filtro.empresa}&usuario=${filtro.usuario}&ano=${filtro.ano}&mes=${filtro.mes}`);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }

  alterar(projecao) {
    return this.put('/',projecao);
  }

  consultar(codigo) {
    return this.get(`/por-codigo/${codigo}`);
  }
}

export default ProjecaoUsuarioSevice